var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStudent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h14v14H0z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m7.623.063 4.354.985c.213.049.366.243.366.462a.47.47 0 0 1-.366.459l-4.37.993c-.4.09-.812.09-1.211 0L2.8 2.144v1.988l.279 1.263a.624.624 0 1 1-1.22 0l.28-1.263V1.996l-.116-.027a.48.48 0 0 1-.369-.462c0-.219.153-.41.37-.46L6.376.064c.41-.087.836-.087 1.246 0M7 7.651a3.548 3.548 0 0 0 3.41-4.528v.005s-1.198.977-3.41.977-3.41-.977-3.41-.977v-.005A3.548 3.548 0 0 0 7 7.65m5.3 1.19 1.11 3.363A1.37 1.37 0 0 1 12.107 14H1.89C.96 14 .3 13.09.587 12.204l1.11-3.363A1.64 1.64 0 0 1 4 7.89c.22.113.457.217.72.312l1.892 1.893c.213.213.56.213.774 0l1.892-1.893q.394-.143.719-.311a1.64 1.64 0 0 1 2.302.949m-.89 2.001a.358.358 0 1 0 0-.716H10.1a.36.36 0 0 0-.357.358.36.36 0 0 0 .358.358z",
  clipRule: "evenodd"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export { SvgStudent as ReactComponent };
export default __webpack_public_path__ + "static/media/student.1f2af9c95df416a9ac3bca7241595f06.svg";